<template>
  <!-- 機器予約 -->
  <div id="HSTDevicePreparationDetail">
    <div id="container">
      <div class="labelTitle lable">睡眠検査機器配送ｻｰﾋﾞｽ 機器予約</div>
      <div class="button-area"><b-button class="backButton is-primary" v-on:click="back">戻る</b-button></div>
      <div id="item-contens">
        <div class="card-content margin-top">
          <table>
            <tr>
              <th>受付番号</th>
              <td><a @click="showDetail(data.receiptNumber)">{{data.receiptNumber}} <b-icon icon="vector-arrange-above"/></a></td>
            </tr>
            <tr>
              <th>医療機関名</th>
              <td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">{{data.hospital}}</td>
            </tr>
            <tr>
              <th>発送タイプ</th>
              <td>{{data.sendType}}</td>
            </tr>
            <tr>
              <th>出荷予定日</th>
              <td>{{data.shippingDate}}</td>
            </tr>
            <tr>
              <th>ePatch同梱の有無</th>
              <td v-if="data.holterRequestId">有</td>
              <td v-else>無</td>
            </tr>
            <tr>
              <th style="vertical-align:top;">患者備考</th>
              <td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">{{data.patientNote}}</td>
            </tr>
            <tr>
              <th style="vertical-align:top;">配送備考</th>
              <td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">{{data.DeliveryInformationNote}}</td>
            </tr>
            <tr>
              <th style="vertical-align:top;">受付備考</th>
              <td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">{{data.receptionNote}}</td>
            </tr>
            <tr>
              <th style="vertical-align:top;">外部ユーザーコメント</th>
              <td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">{{data.belongsNote}}</td>
            </tr>
          </table>
        </div>
        <template v-for="(deviceInfo, index) in data.deviceInfoList">
          <div class="card-content margin-top" :key="index">
          <span style="font-size:20px;">機器情報{{index+1}}</span>
          <table>
            <tr>
              <th>機種</th>
              <td>{{deviceInfo.instrumentKind}}</td>
            </tr>
            <tr v-if="isWP300(deviceInfo.instrumentKind)">
              <th>いびきセンサー同梱の有無</th>
              <td>{{setSnoreSensorValue(deviceInfo.snoreSensor)}}</td>
            </tr>
            <tr>
              <th>シリアルナンバー<span class="require"/></th>
              <td style="width:350px;"><input type="text" :id="'serial' + index" v-model="deviceInfo.serial" :disabled="deviceInfo.status!=2" @keyup.enter="onKeyupEnter(deviceInfo, index)" @focus="isButtonDisable=true" @input="isButtonDisable=true" @blur="focusLost(deviceInfo)"/></td>
              <td>
                <span class="error" v-if="deviceInfo.status==2 && (!deviceInfo.serial && !deviceInfo.leaseupDate)" style="margin-left:10px;">該当する機器が存在しません。</span>
                <span v-else-if="(deviceInfo.status!=2&&deviceInfo.reserveTime) || deviceInfo.leaseupDate" style="margin-left:10px;">リースアップ日：{{deviceInfo.leaseupDate}}、機器予約コード：{{deviceInfo.reserveTime}}</span>
                <span v-else style="margin-left:10px;"><span v-if="deviceInfo.leaseupDate">リースアップ日：{{deviceInfo.leaseupDate}}、</span>機器予約コード：{{deviceInfo.reserveTime}}</span>
              </td>
            </tr>
            <tr>
              <th>電極のロット<span v-if="isNightGraf(deviceInfo.modelId)" class="require"/></th>
              <td style="width:350px;"><input type="text" :id="'electrodeLot' + index" v-model="deviceInfo.electrodeLot" :disabled="!isNightGraf(deviceInfo.modelId)" @keyup.enter="onKeyupEnterElectrodeLot(deviceInfo, index)" @focus="isButtonDisable=true" @input="isButtonDisable=true" @blur="isButtonDisable=false"/></td>
            </tr>
            <tr>
              <th>カニューラのロット<span v-if="isNightGraf(deviceInfo.modelId)" class="require"/></th>
              <td style="width:350px;"><input type="text" :id="'cannulaLot' + index" v-model="deviceInfo.cannulaLot" :disabled="!isNightGraf(deviceInfo.modelId)" @keyup.enter="onKeyupEnterCannulaLot(deviceInfo, index)" @focus="isButtonDisable=true" @input="isButtonDisable=true" @blur="isButtonDisable=false"/></td>
            </tr>
            <tr>
              <th>患者名</th>
              <td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">{{deviceInfo.patientName}}</td>
            </tr>
            <tr>
              <th>カニューラサイズ</th>
              <td>{{deviceInfo.cannulaSize | getNameFilter(cannulaSizeList)}}</td>
            </tr>
            <tr>
              <th>ベルトサイズ</th>
              <td>{{deviceInfo.beltSize | getNameFilter(beltSizeList)}}</td>
            </tr>
          </table>
        </div>
        </template>
        <div class="button-area">
          <b-button class="receptionistButton is-primary" @click="receptionist" :disabled="isButtonDisable">機器予約</b-button>
          <b-button class="backButton is-primary" @click="back">戻る</b-button>
        </div>
      </div>
    </div>
    <floatingModal name="detail-modal" modalClass="detail-modal" @close="closeDetail" title="" width="640" height="480" top="100px" right="100px">
      <hstRequestDetail v-bind:data="data.applicationDetails"/>
    </floatingModal>
  </div>
</template>

<script>
import floatingModal from "@/components/mock/common/FloatingModal";
import HSTRequestDetail from "@/components/mock/common/HSTRequestDetail";
import {choicesType, hstModelValue} from "@/components/mock/base/const.js";

export default {
  name: "HSTRequestAcceptDetail",
  methods: {
    back: function () {
      this.$router.push({
        name: "HSTDevicePreparation",
        params: { searchConditions: this.searchParams },
      });
    },
    isDuplicateSerial: function() {
      // シリアルの重複チェック
      const serialList = []
      this.data.deviceInfoList.map((item) => {
        if(item.serial){
          serialList.push(item.serial)
        }
      });
      const setElements = new Set(serialList);
      if (setElements.size !== serialList.length) {
        return true
      }
      return false
    },
    receptionist: function() {
      this.receptionistData = this.data.deviceInfoList.filter(val => val.serial && val.status==2 && val.reserveTime)
      if(this.receptionistData.length==0){
        this.showErrorMessage("正しいシリアル番号が入力されていません。")
        return
      }
      if(this.isDuplicateSerial()){
        this.showErrorMessage("重複しているシリアル番号があります。")
        return
      }
      for(let i = 0; i < this.receptionistData.length; i++){
        if(this.receptionistData[i].modelId == this.hstModelValue.NIGHTGRAF){
          if(!this.receptionistData[i].electrodeLot){
            this.showErrorMessage("電極のロットが入力されていません。")
            return
          }
          if(!this.receptionistData[i].cannulaLot){
            this.showErrorMessage("カニューラのロットが入力されていません。")
            return
          }
        }
      }
      // 機器予約
      var excuteApi = this.setHstDeviceReservePOST;
      var successCallBack = this.setHstDeviceReservePOSTSuccess;
      var errorCallBack = this.setHstDeviceReservePOSTError;
      // Web Api Call
      this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    setHstDeviceReservePOST: function(client) {
      return client.apis.internalHst.setHstDeviceReservePOST({
        body:this.receptionistData
      });
    },
    setHstDeviceReservePOSTSuccess: function(result) {
      this.showSuccess(result,this.back());
    },
    setHstDeviceReservePOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
    },
    showDetail: function(id) {
      this.$modal.show('detail-modal')
    },
    closeDetail: function(){
      this.$modal.hide('detail-modal')
    },
    doSearch: function() {
      var excuteApi = this.getHstDevicePreparationDetailPOST;
      var successCallBack = this.getHstDevicePreparationDetailPOSTSuccess;
      var errorCallBack = this.getHstDevicePreparationDetailPOSTError;
      // Web Api Call
      this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    getHstDevicePreparationDetailPOST: function(client) {
      return client.apis.internalHst.getHstDevicePreparationDetailPOST({
        body:{receiptNumber:this.targetNumber}
      });
    },
    getHstDevicePreparationDetailPOSTSuccess: function(result) {
      // 検索結果取得
      this.data = result.obj
    },
    getHstDevicePreparationDetailPOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result,this.back());
    },
    onKeyupEnter: function(rowItem, index){
      if(!rowItem.serial){
        return
      }
      //シリアルを取得
      let serialItems = rowItem.serial.split('/');
      if(serialItems.length == 2){
        //　"/"が含まれていたらそれ以降の文字に変更する
        rowItem.serial = serialItems[1]
      }
      if(rowItem.serial){
        var nextElement = document.getElementById("electrodeLot" + (index));
        if(nextElement){
          // 次のアイテムが存在する場合、フォーカスを移動
          nextElement.focus();
        }else{
          // 次のアイテムが存在しない場合、フォーカスを外す
          let element = document.getElementById("electrodeLot" + (index));
          element.blur();
        }
      }
    },
    onKeyupEnterElectrodeLot: function(rowItem, index){
      if(!rowItem.electrodeLot){
        return
      }
      //電極のロットを取得
      let electrodeLotItems = rowItem.electrodeLot.split('/');
      if(electrodeLotItems.length == 2){
        //　"/"が含まれていたらそれ以降の文字に変更する
        rowItem.electrodeLot = electrodeLotItems[1]
      }
      if(rowItem.electrodeLot){
        var nextElement = document.getElementById("cannulaLot" + (index));
        if(nextElement){
          // 次のアイテムが存在する場合、フォーカスを移動
          nextElement.focus();
        }else{
          // 次のアイテムが存在しない場合、フォーカスを外す
          let element = document.getElementById("electrodeLot" + (index));
          element.blur();
        }
      }
    },
    onKeyupEnterCannulaLot: function(rowItem, index){
      if(!rowItem.cannulaLot){
        return
      }
      //カニューラのロットを取得
      let cannulaLotItems = rowItem.cannulaLot.split('/');
      if(cannulaLotItems.length == 2){
        //　"/"が含まれていたらそれ以降の文字に変更する
        rowItem.cannulaLot = cannulaLotItems[1]
      }
      if(rowItem.cannulaLot){
        var nextElement = document.getElementById("serial" + (index + 1));
        if(nextElement){
          // 次のアイテムが存在する場合、フォーカスを移動
          nextElement.focus();
        }else{
          // 次のアイテムが存在しない場合、フォーカスを外す
          let element = document.getElementById("cannulaLot" + (index));
          element.blur();
        }
      }
    },
    focusLost: async function (rowItem) {
      this.searchTarget = rowItem
      if(rowItem.serial){
        var excuteApi = this.getMachineDetailPOST;
        var successCallBack = this.getMachineDetailPOSTSuccess;
        var errorCallBack = this.getMachineDetailPOSTError;
        // WebAPI Call
        await this.apiCall(excuteApi, successCallBack, errorCallBack);
      }else{
        this.isButtonDisable = false
        this.$set(this.searchTarget,"leaseupDate","")
        this.$set(this.searchTarget,"reserveTime","")
      }
    },
    getMachineDetailPOST: function(client) {
      return client.apis.apiCommon.getMachineDetailPOST({ 
        body: {
          serial:this.searchTarget.serial,
          modelId:this.searchTarget.modelId
        } 
      });
    },
    getMachineDetailPOSTSuccess: function(result) {
      var machineDetail = result.obj;
      if(this.isPastday(machineDetail.leaseupDate)){
        // リースアップ日を超えている場合は、警告メッセージ
        var messsge = machineDetail.leaseupDate + "にリースアップ日を超過している機器です。";
        this.$dialog.alert({
          title: '　',
          message: messsge,
        })
        this.$set(this.searchTarget,"serial","")
      }else if(this.isSoon(machineDetail.leaseupDate,2)){
        // リースアップ日が2ヶ月以内の場合近づいている場合は、警告メッセージ
        var messsge = machineDetail.leaseupDate + "にリースアップする機器です。";
        this.$dialog.alert({
          title: '　',
          message: messsge,
        })
        this.$set(this.searchTarget,"serial","")
      }else{
        // リースアップ日をセット
        this.$set(this.searchTarget,"leaseupDate",machineDetail.leaseupDate)
        // 機器予約コードをセット
        this.$set(this.searchTarget,"reserveTime",new Date().getTime())
      }
      this.isButtonDisable = false
    },
    getMachineDetailPOSTError: function(result) {
      // シリアルに一致する利用可能な機器が存在しない場合
      this.$set(this.searchTarget,"serial","")
      this.$set(this.searchTarget,"leaseupDate","")
      this.$set(this.searchTarget,"reserveTime","")
      this.showErrorMessage(result);
      this.isButtonDisable = false
    },
    isWP300: function(instrumentKind) {
      if(instrumentKind && instrumentKind.match(/ウォッチパット300/)){
        return true
      }
      return false
    },
    setSnoreSensorValue: function(snoreSensor) {
      var setSnoreSensorValue = snoreSensor ? "有" : "無";
      return setSnoreSensorValue;
    },
    isNightGraf: function(modelId) {
      if(modelId == hstModelValue.NIGHTGRAF){
        return true
      }
      return false
    },
  },
  data() {
    var targetNumber = this.$route.params["receiptNumber"];
    var searchParams = this.$route.params["searchConditions"];
    var cannulaSizeList = this.getChoiceList(choicesType.cannulaSize, false);
    var beltSizeList = this.getChoiceList(choicesType.beltSize, false);
    cannulaSizeList.unshift({})
    beltSizeList.unshift({})
    return {
      data: {},
      targetNumber,
      searchParams,
      searchTarget:{},
      receptionistData:[],
      cannulaSizeList,
      beltSizeList,
      isButtonDisable:false,
      hstModelValue:hstModelValue
    };
  },
  filters: {
    getNameFilter: function(val, list){
      var target = list.find(item => item.value == val)
      if(target){
        return target.label1
      }
      return ""
    }
  },
  async mounted() {
    // 詳細情報取得
    await this.doSearch();
  },
  components: { 
    floatingModal:floatingModal,
    hstRequestDetail:HSTRequestDetail
  }
};
</script>
<style lang="scss" scoped>
a {
  text-decoration: underline;
}
table.flowTable,
table.flowTable tr,
table.flowTable td {
    border: 1px solid;
    padding: 0px;
    vertical-align: middle;
}
table.flowTable td {
    width: 40px;
    text-align: center;
}

.delay {
    font-weight: bold; 
}
.delay ,
.error {
    color: red;
    margin-left:5px;
}

</style>


// WEBPACK FOOTER //
// src/components/mock/philips/hst/HSTDevicePreparationDetail.vue